import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
    selector: 'app-bar-menu',
    templateUrl: './app-bar-menu.component.html',
    styleUrls: ['./app-bar-menu.component.css'],
    standalone: false
})
export class AppBarMenuComponent implements OnInit {
  @Input() open?: boolean;
  @Output() toggleEvent = new EventEmitter();

  constructor() {}

  ngOnInit(): void {
  }

  toggle(): void {
    this.toggleEvent.emit();
  }
}
